import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export const usageTracker = createTracker({
  events
});
export const standaloneUsageTracker = createTracker({
  standalone: true,
  properties: {
    screen: 'customer-data-properties'
  }
});
export const trackSubmit = stageName => {
  usageTracker.track('revenuestagechangesubmit', {
    stageName
  });
};
export const trackConditionalPropertiesPanelSubmit = () => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    subscreen: `conditional-properties-panel`,
    action: 'submit'
  });
};
export const trackAutosaveSuccess = ({
  identifiers,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    action: 'autosave success',
    type: 'PROPERTY',
    objectTypeId,
    propertyNames: identifiers
  });
};
export const trackAutosaveUndo = ({
  identifiers,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    action: 'autosave undo',
    type: 'PROPERTY',
    propertyNames: identifiers,
    objectTypeId
  });
};
export const trackShowHighlySensitiveValueClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    propertyName,
    objectTypeId,
    action: 'show highly sensitive value'
  });
};
export const trackRejectedReviveDealSubmit = () => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    action: 'revive rejected deal'
  });
};
export const logPageView = payload => {
  usageTracker.track('Pageview', Object.assign({}, payload, {
    screen: `customer-data-properties`
  }));
};
export const trackExpandableTextCollapse = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text collapse',
    propertyName,
    objectTypeId
  });
};
export const trackExpandableTextExpand = ({
  component,
  propertyName,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    subscreen: component,
    action: 'expandable text expand',
    propertyName,
    objectTypeId
  });
};
export const trackDetailsLinkButtonClick = ({
  propertyName,
  objectTypeId,
  type
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    action: 'details link button click',
    type,
    propertyName,
    objectTypeId
  });
};
export const trackDocumentationLinkButtonClick = ({
  propertyName,
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: `customer-data-properties`,
    action: 'property documentation link button click',
    propertyName,
    objectTypeId
  });
};
export const trackFormattedPropertyPhoneClick = ({
  objectTypeId
}) => {
  usageTracker.track('Interaction', {
    screen: 'customer-data-properties',
    action: 'initiate call',
    objectTypeId
  });
};